import axios from "axios";

let GROOVE_API_URL;
if (process.env.REACT_APP_NODE_ENV === "local") {
  GROOVE_API_URL = process.env.REACT_APP_WPQ_GROOVE_API_URL;
} else {
  GROOVE_API_URL = process.env.REACT_APP_API_URL + "wpq";
}

export async function getAllDetails() {
  const response = await axios.get(GROOVE_API_URL + "/WpqDetailsMast")
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}

export async function getAllWPQDetailsGridData(dataObj) {
  try {
    const response = await axios.post(
      GROOVE_API_URL + `/WpqDetailsMast/getallwpqdetailsgriddata`, 
      dataObj,
      { timeout: 30000 }
    );
    return response.data;
  } catch (error) {
    console.error('Grid data fetch error:', error.message);
    return { message: "Unable to find request", status: false };
  }
}

export async function getAllWPSNo() {
  const response = await axios.get(GROOVE_API_URL + "/WpqDetailsMast/allwpsno")
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}

export const getdetailsById = async (IddetailPK, IddetailSK) => {
  let url = `${GROOVE_API_URL}/WpqDetailsMast/getdetailsById`;
  let reqbody = { PK: IddetailPK, SK: IddetailSK }
  const response = await axios.post(url, reqbody)
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

export const DeleteWPQ = async (pkid, skid) => {
  let url = `${GROOVE_API_URL}/WpqDetailsMast/delete`;
  let delBody = { PK: pkid, SK: skid };
  const response = await axios
    .post(url, delBody)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      console.log("error => ", error);
      return { data: { message: "Unable to find request", status: false } };
    });
  return response.data;
};

export const getdetailsByIdTube = async (IdprojectPK, IdprojectSK, IdPK, IdSK) => {
  let url = `${GROOVE_API_URL}/WpqDetailsMast/tubesheet/get`;
  let reqbody = { DetailPK: IdprojectPK, DetailSK: IdprojectSK, PK: IdPK, SK: IdSK }

  const response = await axios.post(url, reqbody)
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });

  return response.data;
};



export const AddNewDetail = (WPQ_Details_Master) => {
  let url = `${GROOVE_API_URL}/WpqDetailsMast`;
  try {
    const response = axios.post(url, WPQ_Details_Master);

    return response;
  } catch (error) {
    console.error("Error in AddNewDetail:", error);
    return { message: "Unable to add detail", status: false };
  }
};


export const updatedatewpq = async (PK, SK, DetailPK, DetailSK, wpqType) => {
  let url = `${GROOVE_API_URL}/WpqDetailsMast/updatedate`;
  let reqbody = { PK: PK, SK: SK, DetailPK: DetailPK, DetailSK: DetailSK, wpqType: wpqType }
  const response = await axios.post(url, reqbody)
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

//Called from WI session
export const updateLastWeldDateFromWI = async (dataObj) => {
  console.log("updateLastWeldDateFromWI ==> ", dataObj);
  let url = `${GROOVE_API_URL}/WpqDetailsMast/updatelastwelddatefromwi`;
  const response = await axios.post(url, dataObj)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

export const getdetailsInWI = async (PK, PK1, SK, SK1) => {
  let url = `${GROOVE_API_URL}/WpqDetailsMast/getdetailsInWI`;
  let reqbody = { PK: PK, PK1: PK1, SK: SK, SK1: SK1 }
  const response = await axios.post(url, reqbody)
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};


export const AddNewDetailTubesheet = async (WPQ_Details_Master) => {
  let url = `${GROOVE_API_URL}/WpqDetailsMast/tubesheet/add`;
  const response = await axios
    .post(url, WPQ_Details_Master)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

//Called from WPQ session for last weld date
export const updateDetailsLastWeldDate = async (dataObj) => {
  let url = `${GROOVE_API_URL}/WpqDetailsMast/updatedetailslastwelddate`;
  const response = await axios
    .post(url, dataObj)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

// NEW: Get recent last weld date for smart date logic
export const getRecentLastWeldDate = async (queryParams) => {
  let url = `${GROOVE_API_URL}/WpqDetailsMast/getrecentlastwelddate`;
  const response = await axios
    .post(url, queryParams)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      console.warn("Could not fetch recent last weld date:", error);
      return { data: null };
    });
  return response.data;
};

export const UpdateWPQDetail = async (WPQ_Detail) => {
  let url = `${GROOVE_API_URL}/WpqDetailsMast/UpdateWPQDetail`;
  const response = await axios
    .post(url, WPQ_Detail)
    .then(function (resp) {
      return resp;
    })// Step 3: Update each detail record with filename only
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

export const Updatedetails = async (WPQ_Details_Master) => {
  let url = `${GROOVE_API_URL}/WpqDetailsMast/update`;
  const response = await axios
    .post(url, WPQ_Details_Master)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

export const uploadwpqgridfile = async (uploadData) => {
  console.log("uploadwpqgridfile uploadData ===> ", uploadData);
  let url = `${GROOVE_API_URL}/WpqDetailsMast/uploadwpqgridfile`;
  const response = await axios
    .post(url, { uploadData })
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      console.log("uploadwpqgridfile error:", error);
      return { message: "Unable to update upload data", status: false };
    });
  return response.data;
};

